import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "comparisonEnd", "details", "field", "image", "output", "preview", "slider", "viewport",
  ]
  static values = { initial: Number }

  connect() {
    this.desktopQuery = window.matchMedia("(min-width: 1200px)")
    this.resizeObserver = new ResizeObserver(() => this.restorePosition())
    this.resizeObserver.observe(this.viewportTarget)
    this.layoutObserver = new ResizeObserver(() => this.syncPreviewHeight())
    this.layoutObserver.observe(this.detailsTarget)
    this.layoutObserver.observe(this.comparisonEndTarget)
    this.handleResize = () => {
      this.syncPreviewHeight()
      this.restorePosition()
    }
    window.addEventListener("resize", this.handleResize)
    this.syncPreviewHeight()
    this.restorePosition()
  }

  disconnect() {
    this.resizeObserver?.disconnect()
    this.layoutObserver?.disconnect()
    window.removeEventListener("resize", this.handleResize)
  }

  imageLoaded() {
    this.syncPreviewHeight()
    this.restorePosition()
  }

  positionFromSlider() {
    if (!this.desktopQuery.matches) return

    const position = Number(this.sliderTarget.value)
    this.setScrollPosition(position)
    this.storePosition(position)
  }

  preventWheel(event) {
    if (this.desktopQuery.matches) event.preventDefault()
  }

  positionFromScroll() {
    if (!this.desktopQuery.matches || this.restoring) return

    const maximum = this.maximumScroll()
    const position = maximum > 0 ? Math.round((this.viewportTarget.scrollTop / maximum) * 100) : 0
    this.sliderTarget.value = position
    this.storePosition(position)
  }

  restorePosition() {
    if (!this.desktopQuery.matches || !this.hasImageTarget || !this.imageTarget.complete) return

    const position = Number(this.fieldTarget.value || this.initialValue)
    this.sliderTarget.value = position
    this.setScrollPosition(position)
    this.storePosition(position)
  }

  setScrollPosition(position) {
    this.restoring = true
    this.viewportTarget.scrollTop = this.maximumScroll() * position / 100
    requestAnimationFrame(() => { this.restoring = false })
  }

  storePosition(position) {
    const roundedPosition = Math.max(0, Math.min(100, Math.round(position)))
    this.fieldTarget.value = roundedPosition
    this.outputTarget.value = `${roundedPosition}%`
  }

  maximumScroll() {
    return Math.max(0, this.viewportTarget.scrollHeight - this.viewportTarget.clientHeight)
  }

  syncPreviewHeight() {
    if (!this.desktopQuery.matches) {
      this.previewTarget.style.removeProperty("height")
      return
    }

    const detailsTop = this.detailsTarget.getBoundingClientRect().top
    const comparisonBottom = this.comparisonEndTarget.getBoundingClientRect().bottom
    this.previewTarget.style.height = `${Math.ceil(comparisonBottom - detailsTop)}px`
  }
}
